/**
 * marka.ts
 *
 * NE İŞE YARAR : Kullanıcıya görünen uygulama adının **tek kaynağı**
 * KAYNAK SPEC  : docs/PROJE-KURALLARI.md ihlal edilemez kural 12 (alan adı ve marka
 *                taşınabilir) · docs/standartlar/09-tasinabilirlik.md
 * BAĞLI OLDUĞU : — (saf sabit)
 * KULLANAN     : src/metin/tr.ts (`ortak.uygulamaAdi`) · src/main.tsx (`document.title`)
 * DİKKAT       : 1) MARKA İLERİDE DEĞİŞECEK — kurum gereksinimi. Bu yüzden ad hiçbir
 *                   bileşene, metne veya sınıf adına gömülmez; buradan okunur.
 *                   Değiştirmek için dokunulacak yerler **kural 12'de sayılıdır** ve
 *                   kapı **G23** listenin dışına çıkılmadığını denetler.
 *                2) `index.html` BAŞLIĞI AYRI DURUR ve bu kaçınılmazdır: sayfa
 *                   yüklenmeden önce JavaScript çalışmaz. `main.tsx` yüklenince
 *                   `document.title` buradan yazılır; `index.html`teki değer yalnız
 *                   ilk karelerde görünen yedektir.
 *                3) `package.json` ADI MARKA DEĞİLDİR. Paket adı ve `yurt_` önekli
 *                   altyapı adları (veritabanı, rol, ortam değişkeni) kullanıcıya
 *                   görünmez ve marka değişince **yeniden adlandırılmaz** — rol adını
 *                   değiştirmek her `GRANT` ve RLS politikasına dokunan bir migration
 *                   demektir ve hiçbir faydası yoktur.
 * SON GÜNCELLEME: 2026-08-31 10:20:00
 */

/** Kullanıcıya görünen uygulama adı. Değiştirmek için kural 12'ye bakınız. */
export const UYGULAMA_ADI = 'Pratik Yurt';
